var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCallGrid(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 134,
    viewBox: "0 0 134 134",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.8858 90.9866C53.2927 90.9866 54.4262 89.7938 54.4262 88.3322V59.2756C54.4262 57.8055 53.2846 56.6211 51.8858 56.6211H4.27677C2.86988 56.6211 1.73633 57.8139 1.73633 59.2756V88.3322C1.73633 89.8022 2.87792 90.9866 4.27677 90.9866H51.8858V90.9866Z",
    stroke: "black",
    strokeWidth: 0.864495,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.535 88.2147C17.4948 87.9627 17.4707 83.8381 17.4707 83.8381C17.4707 79.9152 21.217 76.7314 25.8477 76.7314H30.0362C34.6588 76.7314 38.4132 79.9152 38.4132 83.8381C38.4132 83.8381 38.3891 87.9627 38.3489 88.2147",
    stroke: "black",
    strokeWidth: 0.777997,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9385 73.6317C25.0523 73.6317 22.7129 71.1872 22.7129 68.1716C22.7129 65.1559 25.0523 62.7114 27.9385 62.7114C30.8246 62.7114 33.164 65.1559 33.164 68.1716C33.164 71.1872 30.8246 73.6317 27.9385 73.6317Z",
    stroke: "black",
    strokeWidth: 0.777997,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M103.893 72.6323C104.536 72.6323 105.05 72.0863 105.05 71.4226V58.1501C105.05 57.4781 104.528 56.9404 103.893 56.9404H82.1381C81.495 56.9404 80.9805 57.4865 80.9805 58.1501V71.4226C80.9805 72.0947 81.503 72.6323 82.1381 72.6323H103.893Z",
    stroke: "black",
    strokeWidth: 0.780733,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1923 71.373C88.1762 71.2554 88.1602 69.3734 88.1602 69.3734C88.1602 67.5839 89.8725 66.1304 91.9869 66.1304H93.9003C96.0146 66.1304 97.727 67.5839 97.727 69.3734C97.727 69.3734 97.719 71.2554 97.6948 71.373",
    stroke: "black",
    strokeWidth: 0.780733,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9444 64.702C91.6259 64.702 90.5566 63.5847 90.5566 62.2069C90.5566 60.8292 91.6259 59.7119 92.9444 59.7119C94.2628 59.7119 95.3321 60.8292 95.3321 62.2069C95.3321 63.5847 94.2628 64.702 92.9444 64.702Z",
    stroke: "black",
    strokeWidth: 0.780733,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M103.893 91.2304C104.536 91.2304 105.05 90.6844 105.05 90.0208V76.7482C105.05 76.0762 104.528 75.5386 103.893 75.5386H82.1381C81.495 75.5386 80.9805 76.0846 80.9805 76.7482V90.0208C80.9805 90.6928 81.503 91.2304 82.1381 91.2304H103.893Z",
    stroke: "black",
    strokeWidth: 0.780733,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1923 89.9718C88.1762 89.8542 88.1602 87.9723 88.1602 87.9723C88.1602 86.1829 89.8725 84.7295 91.9869 84.7295H93.9003C96.0146 84.7295 97.727 86.1829 97.727 87.9723C97.727 87.9723 97.719 89.8542 97.6948 89.9718",
    stroke: "black",
    strokeWidth: 0.780733,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9444 83.3096C91.6259 83.3096 90.5566 82.1922 90.5566 80.8144C90.5566 79.4367 91.6259 78.3193 92.9444 78.3193C94.2628 78.3193 95.3321 79.4367 95.3321 80.8144C95.3321 82.1922 94.2628 83.3096 92.9444 83.3096Z",
    stroke: "black",
    strokeWidth: 0.780733,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M131.092 72.6323C131.735 72.6323 132.249 72.0863 132.249 71.4226V58.1501C132.249 57.4781 131.727 56.9404 131.092 56.9404H109.337C108.694 56.9404 108.18 57.4865 108.18 58.1501V71.4226C108.18 72.0947 108.702 72.6323 109.337 72.6323H131.092Z",
    stroke: "black",
    strokeWidth: 0.780733,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M115.39 71.373C115.374 71.2554 115.357 69.3734 115.357 69.3734C115.357 67.5839 117.07 66.1304 119.184 66.1304H121.098C123.212 66.1304 124.924 67.5839 124.924 69.3734C124.924 69.3734 124.916 71.2554 124.892 71.373",
    stroke: "black",
    strokeWidth: 0.780733,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M120.148 64.702C118.83 64.702 117.761 63.5847 117.761 62.2069C117.761 60.8292 118.83 59.7119 120.148 59.7119C121.467 59.7119 122.536 60.8292 122.536 62.2069C122.536 63.5847 121.467 64.702 120.148 64.702Z",
    stroke: "black",
    strokeWidth: 0.780733,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M131.092 91.2304C131.735 91.2304 132.249 90.6844 132.249 90.0208V76.7482C132.249 76.0762 131.727 75.5386 131.092 75.5386H109.337C108.694 75.5386 108.18 76.0846 108.18 76.7482V90.0208C108.18 90.6928 108.702 91.2304 109.337 91.2304H131.092Z",
    stroke: "black",
    strokeWidth: 0.780733,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M115.39 89.9718C115.374 89.8542 115.357 87.9723 115.357 87.9723C115.357 86.1829 117.07 84.7295 119.184 84.7295H121.098C123.212 84.7295 124.924 86.1829 124.924 87.9723C124.924 87.9723 124.916 89.8542 124.892 89.9718",
    stroke: "black",
    strokeWidth: 0.780733,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M120.148 83.3096C118.83 83.3096 117.761 82.1922 117.761 80.8144C117.761 79.4367 118.83 78.3193 120.148 78.3193C121.467 78.3193 122.536 79.4367 122.536 80.8144C122.536 82.1922 121.467 83.3096 120.148 83.3096Z",
    stroke: "black",
    strokeWidth: 0.780733,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallGrid);
export default __webpack_public_path__ + "static/media/call-grid.35330437969981cc773d41d4171bdba0.svg";
export { ForwardRef as ReactComponent };